import { render, staticRenderFns } from "./PAT.vue?vue&type=template&id=8fa64e42&"
import script from "./PAT.vue?vue&type=script&lang=js&"
export * from "./PAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports